// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3SXB8","productName":"Table_productName__1JlBq"};